import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class GetEffectCounterpartListQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(uuid:string): Promise<any> {
    let args = { 
        uuid: uuid
    }
    let res = undefined;
    res = await this.dispatcher.dispatch('get.effect.counterpart.list', args);  
    this.frontend.receivableEffects = res.filter((x) => x.effect_type == 'receivable_effect'); 
    this.frontend.payableEffects  = res.filter((x) => x.effect_type == 'payable_effect');
    this.frontend.filteredEffectsCounterpart = res
    this.frontend.totalEffects = res
    this.frontend.totalEffectsCopy = structuredClone(res);
  }
}